/**
 * Access codes look like `humana-x7k2`: a readable slug plus random characters.
 * Validated client-side only to keep junk out of the URL and the storage key —
 * it is not a security boundary, and the app holds nothing that needs one.
 */
const PATTERN = /^[a-z0-9](?:[a-z0-9-]{1,62}[a-z0-9])$/i;

export function isValidAccessCode(code: string): boolean {
  return PATTERN.test(code);
}

export function normalizeAccessCode(input: string): string {
  return input.trim().toLowerCase();
}
